import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import style from './Landing.module.css';
import logo from '../../../images/common/logo_landing_new.svg';
import URL, { SERVER_URL } from '../../../constants/url';
import axiosApi from '../../../api/daonAxios';
import NaverLogin from './sns/NaverLogin';
import KaKaoLogin from './sns/KakaoLogin';
import GoogleLogin from './sns/GoogleLogin';
import { getDpAuthRefeshTokenSimple, setDpAuthPushInfo, processLogin } from '../../../assets/js/comm';
import MessageTypes from '../../../bridge/messageTypes';
import ToastPopup from '../../../components/comm/ToastPopup';
import CODE from '../../../constants/code';

const Landing = () => {

    const navigate = useNavigate();

    const IITP_CRTFC_TKN = "IITP_CRTFC_TKN";

    // 리프레쉬 토큰
    const [userRequest2, setUserRequest2] = useState(
        { crtfcTknVal: localStorage.getItem(IITP_CRTFC_TKN) }
    );

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //공시사항 팝업 //
    const [showNotice, setShowNotice] = useState( false
        //() => !localStorage.getItem(IITP_CRTFC_TKN)  // 토큰 없을 때만 true
    );

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    /**
     * 푸시 기능부
     */
    const getNativAlrmPermission = () => {
        // 알람권한 및 파이어베이스 푸시토큰 발급 함수
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };

    /**
     * RN으로 푸시 큐 파기 신호 발송
     */
    const flushPendingPush = () => {
        setUserRequest2({});
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'WEB_READY_AUTH_FAIL' }));
        }
    };

    /** 실패 안내는 콜백 페이지와 달리 토스트로 띄운다. */
    const showError = (message) => {
        setToastMessage(message);
        setToast(true);
    };

    /** 네이티브 카카오 로그인 결과 처리. KakaoRedirectPage 의 웹 플로우와 같은 경로다. */
    const handleKakaoNativeLogin = async (accessToken) => {
        if (!accessToken) {
            showError('카카오 로그인에 실패했습니다.');
            return;
        }

        try {
            // 네이티브는 code 가 아니라 accessToken 을 그대로 넘긴다.
            const res = await axiosApi.post('/oauth/kakao', { accessToken });

            const tokens = res.data.result.tokens;
            sessionStorage.setItem('sns_token', tokens.accessToken);
            sessionStorage.setItem('sns_email', tokens.email);

            await processLogin(tokens.accessToken, tokens.email, tokens.nickname, navigate, showError);
        } catch (err) {
            console.error('api/oauth/kakao 호출 중 오류 : ', err);
            showError('카카오 로그인에 실패했습니다.');
        }
    };

    useEffect(() => {

        const handleNativeMessage = async (event) => {
            try {
                // 메시지 파싱
                const data = typeof event.data === 'string'
                    ? JSON.parse(event.data)
                    : event.data;

                if (!data.type) {
                    console.warn('⚠️ type 필드가 없는 메시지 받음:', data);
                    console.warn('⚠️ 이는 RN에서 type을 누락한 것으로 보입니다');
                    return; // type이 없으면 처리하지 않음
                }

                if (data.type === MessageTypes.KAKAO_LOGIN_SUCCESS) {
                    // 네이티브 SDK 가 받아온 accessToken 으로 웹 콜백과 같은 처리를 탄다.
                    await handleKakaoNativeLogin(data.payload?.accessToken);
                    return;
                }

                if (data.type === MessageTypes.KAKAO_LOGIN_FAILURE) {
                    console.warn('카카오 네이티브 로그인 실패:', data.payload?.error);
                    return;
                }

                if (data.type === 'NOTIFICATION_PERMISSION_RESULT') {
                    // RN 에서 결과로 넘겨주는 알람 권한 및 파이어베이스 토큰
                    if (data.granted && data.token) {
                        console.log('✅ 권한 허용됨, 토큰 받음:', data.token);
                        try {
                            // SNS 로그인은 먼저 받은 후에 저장하고
                            // SNS 로그인 처리가 완료되면 dp 서버에 넣어주는 형식때문에
                            // 임시 저장 처리 로직 작성
                            sessionStorage.setItem('pushToken', data.token);

                        } catch (error) {
                            console.error('❌ 토큰 서버 전송 실패:', error);

                        }
                    } else if (data.granted && !data.token) {
                        console.log('⚠️ 권한은 허용됐지만 토큰이 없음 (재확인 메시지)');

                    } else {
                        console.log('❌ 권한 거부됨');
                    }

                } else if (data.type === 'NOTIFICATION_PERMISSION_STATUS') {
                    console.log('📋 권한 상태 확인 메시지 받음');
                    console.log('📋 granted:', data.granted);
                    console.log('📋 origin:', data.origin);

                    /* UI업데이트용 */
                }
            } catch (error) {
                console.error('메시지 처리 오류:', error);
            }
        };

        window.addEventListener('message', handleNativeMessage);
        return () => window.removeEventListener('message', handleNativeMessage);
    }, []);

    useEffect(() => {

        getNativAlrmPermission();
        if (userRequest2.crtfcTknVal && isInitialRender.current) {
            handleFormSubmit2();
            isInitialRender.current = false;
        } else if (!userRequest2.crtfcTknVal && isInitialRender.current) {
            flushPendingPush();
            isInitialRender.current = false;
        }
    }, []);

    /**
     * 세션유지 자동로그인
     * @returns {Element}
     */
    const handleFormSubmit2 = () => {

        getDpAuthRefeshTokenSimple(userRequest2.crtfcTknVal) // 간소화 버전 처리
            .then((data) => {

                const { accessToken, refreshToken } = data;
                localStorage.setItem("jToken", accessToken);
                const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

                const userReq = {
                    crtfcTknVal: refreshToken
                }
                const requestOptions = {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
                axiosApi.post(requestCdssUrl, userReq, requestOptions)
                    .then((resp) => {
                        if (Number(resp.data.resultCode) === Number(CODE.RCV_SUCCESS)) {

                            const iitpUser = resp.data.result.iitpUser;

                            localStorage.setItem("jToken", accessToken);
                            localStorage.setItem(IITP_CRTFC_TKN, refreshToken);
                            sessionStorage.setItem("loginUser", JSON.stringify(iitpUser));

                            if (["11", "12", "13", "14", "15"].includes(iitpUser.usrSeCd)) { // 정상 환자구분코드 checking~
                                if (iitpUser.usrHsptlMap.length > 0) {
                                    // 정상케이스
                                    //setTimeout( () => {
                                    // 정상케이스
                                    if( iitpUser.usrHsptlMap[0].paCd !== undefined && iitpUser.usrHsptlMap[0].paCd !== "" ) {
                                        // 신체활동계수 등록이 완료
                                        navigate(URL.HOME_MAIN);
                                    } else {
                                        // 신체활동계수 미등록일 경우 등록을 유도해야 함.
                                        navigate(URL.ACTIVITY_LEVEL_SELECT);
                                    }
                                    //}, 2000); // 실제 메인이 아니어서 리얼시 떼도 됨.
                                } else {
                                    // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결이 되어야 함
                                    //setTimeout( () => {
                                    setToastMessage('환자연동이 되지 않았습니다. 관리자에 문의해 주십시오!');
                                    setToast(true);
                                    //}, 2000); // 실제 메인이 아니어서 리얼시 떼도 됨.
                                    return false;
                                }
                            } else {
                                // 비정상 유저정보가 로그인시도 하는 경우...
                                setToastMessage("해당 앱을 사용 할수 없는 계정입니다. \n사용자구분 유형을 확인해주세요.");
                                setToast(true);
                                return false;
                            }
                        } else {
                            setToastMessage("리프레쉬 토큰 업데이트에 실패하였습니다.");
                            setToast(true);
                            localStorage.setItem("jToken", "");
                            localStorage.setItem(IITP_CRTFC_TKN, "");
                            sessionStorage.setItem("loginUser", JSON.stringify({}));

                            navigate(URL.LOGIN_MAIN);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setToastMessage("인증정보 업데이트에 실패하였습니다.");
                        setToast(true);
                        localStorage.setItem("jToken", "");
                        localStorage.setItem(IITP_CRTFC_TKN, "");
                        sessionStorage.setItem("loginUser", JSON.stringify({}));

                        navigate(URL.LOGIN_MAIN);
                    });
            })
            .catch(err => {
                console.log(err);
                setToastMessage('인증정보를 가져오지 못했습니다.');
                setToast(true);
                localStorage.setItem("jToken", "");
                localStorage.setItem(IITP_CRTFC_TKN, "");
                sessionStorage.setItem("loginUser", JSON.stringify({}));
                navigate(URL.LOGIN_MAIN);
            });
    }


    return (
        <>
        {
            !userRequest2?.crtfcTknVal &&
            <div className='container' data-padding='none' data-bg-color="white">
                <div className='inner-wrap' data-pad="normal">

                    <div className={style['logo-box']}>
                        <h1><img src={logo} alt=""/></h1>
                    </div>

                    <div className={style['bottom-box']}>
                        <div className={style['main-login-btns']}>
                            <button data-login-btn="normal" onClick={() => navigate(URL.LOGIN_MAIN)}>
                                <span>아이디로 로그인</span>
                            </button>
                        </div>
                        <div className={style['line']}>
                            <span>다른 방법으로 시작하기</span>
                        </div>
                        <div className={style['etc-login-btns']}>
                            <ul>
                                <li>
                                    <KaKaoLogin/>
                                </li>
                                <li>
                                    <NaverLogin/>
                                </li>
                                <li>
                                    <GoogleLogin/>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        }
       </>
  );
};

export default Landing;
